import { writable } from 'svelte/store';

export const answers = writable({
  'kind': null,
  'aim': null,
  'a': {}
});